import React from 'react';
import './CustomProgressBar.scss';
import { Link } from 'gatsby';
import { Swiper, Slide } from 'react-dynamic-swiper';
import 'react-dynamic-swiper/lib/styles.css';

const CustomProgressBar = () => {
  return (
    <div className="ursdagzar">
      <Swiper
        swiperOptions={{
          slidesPerView: 3,
          spaceBetween: 0,
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
          },
          breakpoints: {
            1024: {
              slidesPerView: 2,
            },
            767: {
              slidesPerView: 1,
            },
          },
          speed: 8000,
          longSwipes: true,
        }}
        loop={true}
        navigation={false}
        pagination={false}
      >
        <Slide className="zursdag__slide">
          <Link to="/collections/sale" title="Weihnachts-Sale">
            <div className="text">Weihnachts-Sale ~ Bis zu 50%</div>
          </Link>
        </Slide>
        <Slide className="zursdag__slide">
          <Link to="/collections/sale" title="Weihnachts-Sale">
            <div className="text">Weihnachts-Sale ~ Bis zu 50%</div>
          </Link>
        </Slide>
        <Slide className="zursdag__slide">
          <Link to="/collections/sale" title="Weihnachts-Sale">
            <div className="text">Weihnachts-Sale ~ Bis zu 50%</div>
          </Link>
        </Slide>
      </Swiper>
    </div>
  );
};

export default CustomProgressBar;
